// extracted by mini-css-extract-plugin
export default {"page-title":"pageTitle__page-title___22oul","page-title--mobile":"pageTitle__page-title--mobile___GpGTw","carousel":"pageTitle__carousel___2puiW","nav":"pageTitle__nav___1y4my"};
    if(module.hot) {
      // 1753170523759
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  